<template>
  <v-row no-gutters data-qa="preloginotpinput-row-t8jni">
    <v-flex :class="['otpInput', otpConfig.flex]" data-qa="preloginotpinput-flex-uu0269">
      <OTP-INPUT
        ref="otpData"
        join-character=""
        :length="maxOTPLength"
        @onChange="handleOnChange($event)"
        @onComplete="handleOnComplete"
      />
      <v-row no-gutters justify="start" class="pt-4" data-qa="preloginotpinput-row-hr39f">
        <p v-if="showInvalidOTP" data-qa="preloginotpinput-p-tdq3f8">
          <font
            color="error"
            class="subtitle-2 font-weight-regular"
            >{{ isInvalidOTP() }}</font
          >
        </p>
      </v-row>
      <v-row class="pt-0 mt-0 pb-2" data-qa="preloginotpinput-row-iqqqy5">
        <v-btn
          small
          @click="fetchOTP('resend')"
          :disabled="
            isResendActive.mobile.timerActive || isResendActive.mobile.disabled
          "
          :color="primaryColor"
          text
          data-qa="resendOtp"
          :class="['font-weight-light', 'mr-3']"
          >{{
            !isResendActive.mobile.timerActive
              ? $t("otp.btn.resendOtp")
              : `${$t("otp.resendTimerContent")} ${
                  isResendActive.mobile.counter
                } ${$t("otp.unit.seconds")}`
          }}
        </v-btn>
      </v-row>
    </v-flex>
  </v-row>
</template>

<script>
import '@/styles/common/otpInput.scss'
import event from '@/util/event'
import VueOtp2 from 'vue-otp-2'
import CommonService from '@/service/commonService.js'
import handleError from '@/core/_helpers/errorHandler'
import ShortUniqueId from 'short-unique-id'
const uuid = new ShortUniqueId({ length: 16 })

export default {
  name: 'OtpInput',
  props: {
    otpConfig: Object
  },
  components: {
    'OTP-INPUT': VueOtp2
  },
  data () {
    return {
      otp: null,
      otpCopy: undefined,
      maxOTPLength: this.$appSettings.defaultConfigurations.maxOTPLength,
      defaultMessageCode:
        this.$appSettings.defaultConfigurations.b2cOtpMessageCode,
      otpRegex: this.$appSettings.defaultConfigurations.commonOTPInputRegex,
      isValidLength: false,
      showInvalidOTP: false,
      showInvalidOTPMsg: '',
      otpTimeInterval:
        this.$appSettings.defaultConfigurations.otpResendTimeInterval,
      resendBtnDark: false,
      isRegMatched: false,
      shortuuid: '',
      oldPassword: '',
      userLoginId: '',
      isResendActive: {
        mobile: {
          timerActive: false,
          disabled: false,
          counter: 0
        }
      },
      fromScreen: this.otpConfig.fromScreen || '',
      otpMessage: this.$t('login.preLoginOTPMessages.defaultMsg')
    }
  },
  created () {
    event.$emit('OTP_INIT', true)
    event.$on('SEND_OTP', (isTrigger) => {
      if (isTrigger) {
        this.fetchOTP('initial')
      }
    })
    event.$on('reset_OTPField', (arg) => {
      if (arg) {
        this.resetOtpData()
      }
    })
    event.$on('prelogin_invalid_otp', () => {
      this.showInvalidOTP = true
      this.showInvalidOTPMsg = this.$t('otp.invalidOtp')
      this.otp = ''
      this.$refs.otpData.otp = []
      this.isValidLength = false
    })
    event.$on('prelogin_resend_otp', (args) => {
      if (args) {
        this.fetchOTP()
        event.$emit('OTP_RESENT', true)
        this.runTimer('mobile', this.otpTimeInterval)
        this.otp = ''
        this.$refs.otpData.otp = []
        this.showInvalidOTP = true
        this.showInvalidOTPMsg = this.$t('otp.autoResendMsg')
        this.isValidLength = false
        this.isResendActive.mobile.disabled = true
      }
    })
    event.$on('fetchUserLoginId', (arg) => {
      this.userLoginId = arg.userLoginId
      this.oldPassword = arg.oldPassword
    })
  },
  methods: {
    handleOnComplete (input) {
      const content = input.values()
      this.otp = ''
      for (const value of content) {
        if (value) {
          this.otp = this.otp ? `${this.otp}${value}` : value
        }
      }
      if (this.otp && this.otp.length === this.maxOTPLength) {
        this.isValidLength = true
      }
    },
    handleOnChange (value) {
      let filterOTPArr = []
      if (value && value.value && value.value.length) {
        this.isValidRegEx(value.value)
        if (this.isRegMatched && value.value.length === 1) {
          this.$refs.otpData.otp.splice(value.index, 1, value.value)
          this.otpCopy = this.$refs.otpData.otp
        } else {
          this.$refs.otpData.otp.splice(value.index, 1)
          filterOTPArr = this.$refs.otpData.otp.filter(value => (value !== null))
          if (value.index === (this.maxOTPLength - 1) && value.value === 'Enter') {
            this.$refs.otpData.otp[value.index] = this.otpCopy[this.otpCopy.length - 1]
            this.validateOTP()
          }
        }
      }
      if (filterOTPArr < this.maxOTPLength) {
        this.isValidLength = false
        this.showInvalidOTP = false
      }
    },
    isValidRegEx (string) {
      const pattern = new RegExp(this.otpRegex)
      this.isRegMatched = pattern.test(string)
    },
    handleClearInput () {
      this.otp = ''
      if (this.$refs.otpData && this.$refs.otpData.otp) {
        this.$refs.otpData.otp = []
      }
    },
    isInvalidOTP () {
      return this.showInvalidOTP ? this.showInvalidOTPMsg : ''
    },
    resetOtpData () {
      this.handleClearInput()
      this.showInvalidOTP = false
      this.isResendActive.mobile.disabled = false
      this.isValidLength = false
    },
    resendOTP () {
      event.$emit('OTP_RESENT', true)
      this.runTimer('mobile', this.otpTimeInterval)
      this.otp = ''
      this.$refs.otpData.otp = []
      this.showInvalidOTP = false
      this.isValidLength = false
      this.isResendActive.mobile.disabled = true
      this.$store.dispatch('appStore/setAppData', {
        message: {
          content: this.$t('otp.resendMessage'),
          type: 'success',
          component: 'dob-snackbar'
        }
      })
    },
    async fetchOTP (type = 'initial') {
      let isOtpEnabled = false
      this.userLoginId = this.otpConfig.userLoginId
      switch (this.fromScreen) {
        case 'activateUser':
          isOtpEnabled = this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.enableOTP
          this.otpMessage = this.$t('login.preLoginOTPMessages.activateUser')
          break
        case 'retrieveLoginId':
          isOtpEnabled = this.$appSettings.defaultConfigurations.loginPageScreens.retrieveLoginIdScreen.enableOTP
          break
        case 'forgotPassword':
          isOtpEnabled = this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.enableOTP
          this.otpMessage = this.$t('login.preLoginOTPMessages.resetPassword')
          break
        case 'changePassword':
          isOtpEnabled = this.$appSettings.defaultConfigurations.loginPageScreens.changeExpiredOrTempPassword.enableOTP
          break
        default:
          isOtpEnabled = true
          break
      }
      this.resetOtpData()
      if (this.$appSettings.authConfigurations.enableB2C && isOtpEnabled) {
        this.shortuuid = uuid.rnd()

        if (!this.isResendActive.mobile.timerActive) {
          this.isResendActive.mobile.timerActive = !(type === 'initial')
          this.handleClearInput()
          try {
            this.handleClearInput()
            // Call GenerateOTP API
            if (this.fromScreen === 'changePassword') {
              const generateB2COtpPayload = {
                messageCode: this.defaultMessageCode,
                userLoginId: this.userLoginId
              }
              await CommonService.getOTP(generateB2COtpPayload)
            } else {
              const partyData =
              this.$store.getters['profileStore/profileData'].partyDetails

              const generateB2BOtpPayload = {
                mobilePhoneNumber: partyData.phoneNumber || '',
                emailId: partyData.emailAddress || '',
                mobileCountryCode: partyData.countryCode || this.$appSettings.defaultConfigurations.countryISDCode,
                referenceNumber: this.shortuuid,
                customerId: partyData.customerID,
                message: this.otpMessage
              }
              await CommonService.getB2BOTP(generateB2BOtpPayload)
            }

            if (type === 'resend') {
              this.resendOTP()
            }
          } catch (e) {
            handleError(e)
          }
        }
      } else {
        if (type === 'resend') {
          this.resendOTP()
        }
      }
    },
    runTimer (type, timeInterval) {
      this.isResendActive[type].timerActive = true
      this.isResendActive[type].counter = timeInterval / 1000
      const timerInterval = setInterval(() => {
        this.isResendActive[type].counter -= 1
        if (this.isResendActive[type].counter < 1) {
          this.isResendActive[type].timerActive = false
          this.isResendActive.mobile.disabled = false
          clearInterval(timerInterval)
        }
      }, 1000)
    },
    sendOtpDetails () {
      if (this.fromScreen === 'changePassword') {
        const validateOtpPayload = {
          otp: this.otp,
          userLoginId: this.userLoginId
        }
        event.$emit('prelogin_otp_data_ready', validateOtpPayload)
      } else {
        const partyData = this.$store.getters['profileStore/profileData'].partyDetails
        const B2BOtpPayload = {
          mobilePhoneNumber: partyData.phoneNumber || '',
          emailId: partyData.emailAddress || '',
          mobileCountryCode: partyData.countryCode || '',
          referenceNumber: this.shortuuid || '',
          otp: this.otp
        }
        event.$emit('prelogin_otp_data_ready', B2BOtpPayload)
      }
    }
  },
  watch: {
    isValidLength () {
      event.$emit('prelogin_otp_valid_length', this.isValidLength)
      if (this.isValidLength) {
        this.sendOtpDetails()
      }
    }
  },
  beforeDestroy () {
    event.$off('SEND_OTP', false)
    event.$off('prelogin_resend_otp')
  }
}
</script>
